import { useMemo } from 'react';

import { BOOLEAN_STRINGS } from 'shared/consts';
import { useSearchParams } from 'hooks/use-search-params.hook';
import { searchParams as SearchParams } from 'shared/types/search-params';

/**
 * How many filters the list has applied, for the badge on the filter button.
 *
 * One per group of the shared filter modal rather than one per value: three resource types selected
 * is one filter narrowed three ways, and the count has to mean the same thing as the modal's
 * "Clear all" — how much there is to clear.
 *
 * The date and time are counted even though the date field shows them beside the button. They are
 * filters the modal owns and clears, and the icon they replace treated them as filters too
 * (`FilterIcon`'s active dot), so leaving them out would quietly change what "filtered" means.
 */
export const useListFilterCount = (): number => {
  const queryParams = useSearchParams<SearchParams>();

  return useMemo(() => {
    const {
      filterByType,
      filterByCollection,
      startDate,
      startDates,
      startTime,
      endTime,
      duration,
      capacity,
      filterByFloor,
      presetWindows,
      availableNow,
    } = queryParams;

    return [
      filterByType,
      filterByCollection,
      startDate || startDates,
      startTime || endTime,
      duration,
      capacity,
      filterByFloor,
      presetWindows,
      availableNow === BOOLEAN_STRINGS.TRUE ? availableNow : undefined,
    ].filter(Boolean).length;
  }, [queryParams]);
};
